var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Watch, PropertyConverters, Components } from '@pacem/pacem-core';
import { MarkdownService } from './markdown-svc';
//namespace Pacem.Components.UI {
let PacemMarkdownElement = class PacemMarkdownElement extends Components.PacemElement {
    constructor(_md = new MarkdownService()) {
        super();
        this._md = _md;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'value') {
            this.innerHTML = this.html();
        }
    }
    // IDEA: allow extensible parsing (grammar components?...)
    tokens(md = this.value) {
        return this._md.tokenize(md);
    }
    html(md = this.value) {
        return this._md.toHtml(md);
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemMarkdownElement.prototype, "value", void 0);
PacemMarkdownElement = __decorate([
    CustomElement({ tagName: P + '-markdown' })
], PacemMarkdownElement);
export { PacemMarkdownElement };
